export default __webpack_public_path__ + "static/media/2287.553b8d12.png";